<template>
  <v-card>
    <ValidationObserver ref="obs" v-slot="{ invalid, validated }">
      <v-toolbar dense :elevation="0" color="background darken-1">
        <v-toolbar-title>{{ $Amplify.I18n.get(title) }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon color="secondary" @click.stop="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-alert
          v-if="alert.message"
          v-model="alert.show"
          prominent
          dense
          dismissible
          :type="alert.type || 'error'"
          transition="scale-transition"
        >
          <v-layout align-center wrap>
            <div>
              {{ alert.message }}
            </div>
          </v-layout>
        </v-alert>

        <!-- <ValidationProvider
          name="column"
          rules="required"
          v-slot="{ errors, valid }"
        >
          <v-select
            :items="columns"
            label="Buscar en la columna"
            v-model="filter.field"
            item-text="label"
            return-object
            @change="fieldChange"
            :error-messages="errors"
            :success="valid"
            outlined
          ></v-select>
        </ValidationProvider> -->

        <ValidationProvider
          v-if="filter.field.component == 'text'"
          :name="filter.field.label"
          rules="required"
          v-slot="{ errors, valid }"
        >
          <v-text-field
            v-model="filter.param"
            :label="$Amplify.I18n.get('Palabra(s) Clave(s)') + ' *'"
            autofocus
            :error-messages="errors"
            :success="valid"
            outlined
            clearable
            @keyup.enter="editMode ? updateFilter(filter) : addfilter(filter)"
          ></v-text-field>
        </ValidationProvider>

        <ValidationProvider
          v-if="filter && filter.field.component == 'select'"
          :name="filter.field.label"
          rules="required"
          v-slot="{ errors, valid }"
        >
          <v-select
            v-model="filter.param"
            :items="items"
            :loading="isLoading"
            :menu-props="{ maxHeight: '250' }"
            :label="filter.field.label"
            multiple
            item-text="key"
            item-value="key"
            persistent-hint
            autofocus
            outlined
          >
          </v-select>
        </ValidationProvider>

        <v-data-table
          v-if="filter.field.component == 'datatable'"
          :headers="headers"
          :items="items"
          :loading="isLoading"
          item-key="key"
          :dense="true"
          class="elevation-0"
        >
          <template v-slot:top>
            <ValidationProvider
              :name="filter.field.label"
              rules="required"
              v-slot="{ errors, valid }"
            >
              <v-text-field
                v-model="filter.param"
                @input="buscar(filter.param)"
                label="Escriba una palabra para la búsqueda"
                class="mx-0"
                autofocus
                clearable
                :error-messages="errors"
                :success="valid"
                messages="Use el comodín * en su búsqueda para agregar todos los registros"
                outlined
              >
              </v-text-field>
            </ValidationProvider>

            <span class="title">Resultado de la Búsqueda [Vista Previa]</span>
            <v-alert
              icon="mdi-lightbulb-outline"
              text
              prominent
              type="primary"
              v-if="usingWildcard"
            >
              Esta usando el comodín * en su pabra de búsqueda, el analizador de
              consulta devolverá todos los registros que coincidan con cada uno
              de los items de la lista de abajo
            </v-alert>
          </template>
          <template v-slot:item.key="{ item }">
            <div style="display:block" v-on:dblclick="transcribir(item)">
              {{ item.key }}
            </div>
          </template>
          <template v-slot:item.value="{ item }" v-if="!usingWildcard">
            <v-btn text small color="primary" v-on:click="transcribir(item)"
              >SELECCIONAR</v-btn
            >
          </template>
        </v-data-table>

        <!--         <ValidationProvider
          v-if="filter.field.component == 'text' && showDefaulOperatorSelector"
          name="Operador"
          rules="required"
          v-slot="{ errors, valid }"
        >
          <v-autocomplete
            :items="operators"
            v-model="filter.default_operator"
            label="Operador"
            item-text="label"
            item-value="label"
            outlined
          ></v-autocomplete>
        </ValidationProvider> -->

        <ValidationProvider
          v-if="filter.field.component == 'autocomplete'"
          :name="filter.field.label"
          rules="required"
          v-slot="{ errors, valid }"
        >
          <v-autocomplete
            v-model="filter.param"
            :items="items"
            :loading="isLoading"
            :search-input.sync="search"
            clearable
            item-text="key"
            item-value="key"
            :hide-no-data="false"
            :label="filter.field.label"
            :autofocus="!editMode"
            :menu-props="{
              maxHeight: 250
            }"
            outlined
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title> Escriba una palabra</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-autocomplete>
        </ValidationProvider>

        <v-container v-if="filter.field.component == 'range'">
          <v-row v-if="filter.field.valueFormat == 'date'">
            <v-tabs v-model="tab">
              <v-tabs-slider></v-tabs-slider>
              <v-tab href="#tab-1" class="pa-0 ma-0">
                Absoluto
              </v-tab>
              <v-tab href="#tab-2" class="pa-0 ma-0">
                Relativo
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item value="tab-1">
                <v-row cols="2" class="mt-0" v-if="tab == 'tab-1'">
                  <v-col>
                    <ValidationProvider
                      name="desde"
                      rules="required"
                      v-slot="{ errors, valid }"
                    >
                      <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="35"
                        :return-value.sync="filter.param[0]"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        ><template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :value="computedDateTimeFormatted(date2, time2)"
                            label="Desde"
                            prepend-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="date2" flat scrollable>
                          <v-btn text disabled> </v-btn>
                        </v-date-picker>

                        <v-time-picker
                          v-model="time2"
                          flat
                          format="24hr"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu2 = false">
                            Cancelar
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu2.save(`${date2} ${time2}`)"
                          >
                            OK
                          </v-btn>
                        </v-time-picker>
                      </v-menu>
                    </ValidationProvider>
                  </v-col>

                  <v-col>
                    <ValidationProvider
                      name="hasta"
                      rules="required"
                      v-slot="{ errors, valid }"
                    >
                      <v-menu
                        ref="menu3"
                        v-model="menu3"
                        :close-on-content-click="false"
                        :nudge-right="35"
                        :return-value.sync="filter.param[1]"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :value="computedDateTimeFormatted(date3, time3)"
                            label="Hasta"
                            prepend-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>

                        <v-date-picker v-model="date3" flat scrollable>
                          <v-btn text disabled> </v-btn>
                        </v-date-picker>

                        <v-time-picker
                          v-model="time3"
                          flat
                          format="24hr"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu3 = false">
                            Cancelar
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu3.save(`${date3} ${time3}`)"
                          >
                            OK
                          </v-btn>
                        </v-time-picker>
                      </v-menu>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item value="tab-2">
                Las fechas relativas admiten matemática de fechas y son
                adecuadas para consultas almacenadas. Puede escribir matemática
                de fechas usando formato legible para humanos, por ejemplo,
                puede escribir "now" seguida de una o más expresiones
                matemáticas como:

                <br />
                <strong>+1H: </strong>Agregar una hora (H= hora del día (0-23),
                h= hora en formato am/pm (1-12))

                <br />
                <strong>-1d: </strong>Restar un día
                <br />
                <strong>/d: </strong> Redondear hacia abajo al día más cercano
                <br /><br />
                <strong> Ejemplos:</strong>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Desde
                        </th>
                        <th class="text-left">
                          Hasta
                        </th>
                        <th class="text-left">
                          Descripción
                        </th>
                        <th class="text-left"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="sample in samples" :key="sample.descripcion">
                        <td>{{ sample.desde }}</td>
                        <td>{{ sample.hasta }}</td>
                        <td>{{ sample.descripcion }}</td>
                        <td>
                          <v-btn icon @click="copiar(sample)">
                            <v-icon small>mdi-content-copy</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <br /><br />
                <v-row cols="2" class="mt-2">
                  <v-col>
                    <ValidationProvider
                      v-if="tab == 'tab-2'"
                      name="desde-relativo"
                      rules="required"
                      v-slot="{ errors, valid }"
                    >
                      <v-text-field
                        v-model="filter.param[0]"
                        autofocus
                        hide-details
                        label="Desde"
                        prepend-icon="mdi-calendar"
                        :error-messages="errors"
                        :success="valid"
                        outlined
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col>
                    <ValidationProvider
                      name="hasta-relativo"
                      rules="required"
                      v-slot="{ errors, valid }"
                    >
                      <v-text-field
                        v-model="filter.param[1]"
                        hide-details
                        label="Hasta"
                        prepend-icon="mdi-calendar"
                        :error-messages="errors"
                        :success="valid"
                        outlined
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-row>

          <v-row v-else>
            <v-col>
              <ValidationProvider
                name="desde"
                rules="required"
                v-slot="{ errors, valid }"
              >
                <v-text-field
                  v-model="filter.param[0]"
                  autofocus
                  hide-details
                  type="number"
                  label="Desde"
                  :prefix="filter.field.valueFormat == 'number' ? '' : '$'"
                  :error-messages="errors"
                  :success="valid"
                  outlined
                ></v-text-field>
              </ValidationProvider>
            </v-col>

            <v-col>
              <ValidationProvider
                name="hasta"
                rules="required"
                v-slot="{ errors, valid }"
              >
                <v-text-field
                  v-model="filter.param[1]"
                  hide-details
                  label="Hasta"
                  type="number"
                  :prefix="filter.field.valueFormat == 'number' ? '' : '$'"
                  :error-messages="errors"
                  :success="valid"
                  outlined
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          v-if="editMode"
          :disabled="
            (invalid || !validated || loadingBtn) &&
              filter.field.valueFormat != 'date'
          "
          @click="updateFilter(filter)"
          color="primary"
        >
          {{ $Amplify.I18n.get("Update Filter") }}
        </v-btn>

        <v-btn
          v-else
          :disabled="
            (invalid || !validated || loadingBtn) &&
              filter.field.valueFormat != 'date'
          "
          @click="addfilter(filter)"
          color="primary"
        >
          {{ $Amplify.I18n.get("Add Filter") }}
        </v-btn>
      </v-card-actions>
    </ValidationObserver>
  </v-card>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";

import columns from "@/assets/columns";
import operators from "@/assets/operators";

import { mapGetters, mapActions } from "vuex";
import { getFiltros } from "@/api/private/filtros";

export default {
  name: "FilterComponent",
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    filter: {
      type: Object,
      default: function() {
        return {
          field: { label: "", value: "", component: "" },
          param: null,
          default_operator: null,
          excludeInView: []
        };
      }
    }
  },
  data() {
    return {
      tab: "tab-1",
      timerId: null,
      editMode: false,
      loadingBtn: false,
      usingWildcard: false,
      alert: {
        show: false,
        type: "",
        message: ""
      },
      columns,
      operators,
      items: [],
      isLoading: false,
      // Revisar de aqui para abajo
      search: null,
      error: "",
      logger: {},
      headers: [
        { text: "Descripción", value: "key" },
        { text: "", value: "value" }
      ],

      menu: false,
      modal: false,
      menu2: false,
      date2: undefined,
      time2: "00:00",
      menu3: false,
      date3: undefined,
      time3: "00:00",
      samples: [
        {
          desde: "now/d",
          hasta: "now",
          descripcion: "Muestra siempre los procesos publicados el día de hoy"
        },
        {
          desde: "now-1d/d",
          hasta: "now-1d/d",
          descripcion: "Muestra siempre los procesos publicados el día de ayer"
        },
        {
          desde: "now-1d/d",
          hasta: "now/d",
          descripcion:
            "Muestra siempre los procesos publicados entre ayer y hoy"
        },
        {
          desde: "now-4H-5H",
          hasta: "now",
          descripcion:
            "Muestra siempre los procesos publicados durante las últimas 4 horas (4H) hora de Ecuador (-5H)"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["filters"]),
    title() {
      return this.editMode ? "Edit Filter" : "New Filter";
    },
    computedDateTimeFormatted: function() {
      return (date, time) => (date ? `${date} ${time}` : "");
    },
    showDefaulOperatorSelector: function() {
      return this.filter.param.split(" ").length > 1 &&
        this.filter.param.split(" AND ").length < 2 &&
        this.filter.param.split(" OR ").length < 2
        ? true
        : false;
    }
  },
  mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);
  },
  watch: {
    search: async function(val) {
      clearTimeout(this.timerId);
      this.isLoading = false;
      //console.log("search:");
      if (val) {
        this.buscar(val);
      }
    }
  },
  methods: {
    ...mapActions([
      "addFilterAction",
      "updateFilterAction",
      "hideAddOrEditFilterDialog"
    ]),
    dateIsValid: function dateIsValid(date) {
      return date instanceof Date && !isNaN(date);
    },
    copiar: function(sample) {
      console.log(sample);
      this.filter.param = [`${sample.desde}`, `${sample.hasta}`];
    },
    sqlToJsDate: function(date_string) {
      var t,
        result = null;
      if (typeof date_string === "string") {
        t = date_string.split(/[- :]/);
        //when t[3], t[4] and t[5] are missing they defaults to zero
        //result = new Date(t[0], t[1] - 1, t[2], t[3] || 0, t[4] || 0, t[5] || 0);
        result = new Date(
          Date.UTC(t[0], t[1] - 1, t[2], t[3] || 0, t[4] || 0, t[5] || 0)
        );
      }
      // console.log('sqlToJsDate', result )
      return result;
    },
    buscar: async function(keywords) {
      clearTimeout(this.timerId);
      this.isLoading = false;

      this.usingWildcard = keywords.indexOf("*") > -1 ? true : false;

      if (keywords.length < 3) return;
      this.timerId = setTimeout(async () => {
        this.isLoading = true;
        let result = await getFiltros(this.filter.field.value, keywords);
        this.items = result.data.json;
        this.isLoading = false;
      }, 500);
    },
    transcribir: function(item) {
      this.filter.param = item.key;
      this.loadingBtn = true;
      if (this.editMode) {
        this.updateFilter(this.filter);
      } else {
        this.addfilter(this.filter);
      }
      //this.addfilter();
    },
    fieldChange: function() {
      console.log("field has changed");
      this.item = [];
      switch (this.filter.field.component) {
        case "text":
        case "datatable":
          this.filter.param = "";
          break;
        case "range":
          this.filter.param = [];
          break;
        default:
          this.filter.param = null;
          this.loadFilterData();
      }
    },

    loadFilterData: async function() {
      this.isLoading = true;
      this.items = [];
      let result =
        (this.filter.field.component == "autocomplete" ||
          this.filter.field.component == "datatable") &&
        this.editMode
          ? await getFiltros(this.filter.field.value, this.filter.param)
          : this.filter.field.component == "select"
          ? await getFiltros(this.filter.field.value)
          : null;
      this.items = result ? result.data.json : [];
      this.isLoading = false;
    },
    addfilter: function(filter) {
      //this.setAlert({});
      //if (this.filters.some(item => item.field.value === filter.field.value)) {
      //this.setError(`Ya existe un filtro ${filter.field.label}`);
      //} else {
      this.addFilterAction(filter);
      this.close();
      //}
    },
    updateFilter: function(filter) {
      this.updateFilterAction(filter);
      this.close();
    },
    setError(e) {
      this.loadingBtn = false;
      this.error = this.$Amplify.I18n.get(e.message || e);
      this.setAlert({ message: this.error });
      this.logger.error(this.error);
    },
    setAlert: function({ message = "", type = "error" }) {
      this.alert = {
        message,
        type,
        show: message.length > 1 ? true : false
      };
    },
    close: function() {
      this.hideAddOrEditFilterDialog();
    }
  },
  beforeCreate: function() {
    AmplifyEventBus.$on("edit-filter", filter => {
      if (filter) {
        this.editMode = true;

        Object.assign(this.filter, filter);

        this.$nextTick(() => {
          if (this.filter.field.valueFormat == "date") {
            if (this.dateIsValid(new Date(this.filter.param[0]))) {
              this.tab = "tab-1";
              [this.date2, this.time2] = this.filter.param[0].split(" ");
              this.$refs.menu2.save(`${this.date2} ${this.time2}`);

              [this.date3, this.time3] = this.filter.param[1].split(" ");
              this.$refs.menu3.save(`${this.date3} ${this.time3}`);
            } else {
              this.tab = "tab-2";
            }
          }
          this.$refs.obs.validate();
        });
        this.loadFilterData();
      }
    });

    AmplifyEventBus.$on("create-filter", field => {
      if (field) {
        Object.assign(this.filter.field, field);
        this.fieldChange();
      }
    });
  },
  beforeDestroy: function() {
    AmplifyEventBus.$off("edit-filter");
    AmplifyEventBus.$off("create-filter");
  }
};
</script>
